import { compareAsc, subYears, parseISO, differenceInYears } from 'date-fns';
import {
  courseDiscountTypeByStates,
  courseDiscountsAges,
  additionalDriverDiscountsTypesByStates,
  seniorDiscountByAgeOnlyStates,
  courseDiscountTypes,
  communityDriveAvailableStates
} from '@ourbranch/lookups';

// it is actually 23 but needs to be compared to the policy rate control date, and this is a
// hot fix to make it show up; the back end will handle not rating properly, so this is OK
// but it's also fine to fix this in the future to do the comparison against the rate control date
const fullTimeStudentAgeLimit = 24;

// MARK: full time student
export const canPersonBeFullTimeStudent = ({ driverOrPerson, driversOrPeople }) => {
  const isPrimaryMarried = driversOrPeople.some((d) => {
    return d.isPrimary && d.maritalStatus === 'M';
  });
  const isSpouseOfPrimary = driverOrPerson.isCoApplicant && driverOrPerson.maritalStatus === 'M' && isPrimaryMarried;

  // if 23 and under, and not primary, and not married to primary, then eligible for student discount
  const canBeFullTimeStudent =
    compareAsc(subYears(new Date(), fullTimeStudentAgeLimit), parseISO(driverOrPerson.dateOfBirth)) === -1 &&
    !driverOrPerson.isPrimary &&
    !isSpouseOfPrimary; // if 23 and under, and not primary, and not married to primary, then eligible for student discount

  return canBeFullTimeStudent;
};

// MARK: driving course
export const canPersonReceiveDrivingCourseDiscount = ({ driverOrPerson, state }) => {
  const today = new Date();
  const birthDate = new Date(driverOrPerson.dateOfBirth);
  const age = differenceInYears(today, birthDate);
  const drivingCourseDiscountType = courseDiscountTypeByStates[state];

  // check if there is a state specific age limit for the discount (different from Inexperienced)
  const canReceiveDrivingCourseDiscount =
    drivingCourseDiscountType &&
    drivingCourseDiscountType !== courseDiscountTypes.INEXPERIENCED &&
    (seniorDiscountByAgeOnlyStates[state]
      ? age >= seniorDiscountByAgeOnlyStates[state]
      : age >= courseDiscountsAges[state]);

  // check if there is a state specific age to calculate Inexperienced discount
  const canReceiveInexperiencedDrivingCourseDiscount =
    drivingCourseDiscountType &&
    drivingCourseDiscountType === courseDiscountTypes.INEXPERIENCED &&
    age - driverOrPerson.ageFirstLicensed < courseDiscountsAges[state];

  return {
    canReceiveDrivingCourseDiscount,
    canReceiveInexperiencedDrivingCourseDiscount,
    canReceiveAdditionalDrivingCourseDiscount: additionalDriverDiscountsTypesByStates[state]?.condition
  };
};

// MARK: community drive
export const canReceiveCommunityDriveDiscount = ({ state, isBix }) => {
  return (
    communityDriveAvailableStates[state] &&
    ((isBix && communityDriveAvailableStates[state].showForBix) ||
      (!isBix && communityDriveAvailableStates[state].showForNonBix))
  );
};
